// extracted by mini-css-extract-plugin
module.exports = {"description":"_e76b7a6","value":"_cb68e6e"};